export default __webpack_public_path__ + "static/media/icn-info.ecf7446a.svg";